import { Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[redBooleanToEnabled]',
  standalone: false
})
export class BooleanToEnabledDirective implements OnChanges {
  @Input('redBooleanToEnabled') enabled: boolean | null | undefined = false;

  element: ElementRef;

  constructor() {
    this.element = inject(ElementRef);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['enabled']) {
      switch (changes['enabled'].currentValue) {
        case true:
          this.element.nativeElement.innerText = 'Enabled';
          this.element.nativeElement['color'] = 'success';
          break;
        default:
          this.element.nativeElement.innerText = 'Disabled';
          this.element.nativeElement['color'] = 'danger';
          break;
      }
    }
  }
}
